/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Attr_YieldInputs */

const en_attr_yield = /** @type {(inputs: Attr_YieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yield`)
};

const th_attr_yield = /** @type {(inputs: Attr_YieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผลผลิต`)
};

const ja_attr_yield = /** @type {(inputs: Attr_YieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`収量`)
};

const fr_attr_yield = /** @type {(inputs: Attr_YieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendement`)
};

const es_attr_yield = /** @type {(inputs: Attr_YieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendimiento`)
};

const ru_attr_yield = /** @type {(inputs: Attr_YieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Урожайность`)
};

const zh_attr_yield = /** @type {(inputs: Attr_YieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`产量`)
};

const vi_attr_yield = /** @type {(inputs: Attr_YieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Năng suất`)
};

/**
* | output |
* | --- |
* | "Yield" |
*
* @param {Attr_YieldInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const attr_yield = /** @type {((inputs?: Attr_YieldInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Attr_YieldInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_attr_yield(inputs)
	if (locale === "ja") return ja_attr_yield(inputs)
	if (locale === "fr") return fr_attr_yield(inputs)
	if (locale === "es") return es_attr_yield(inputs)
	if (locale === "ru") return ru_attr_yield(inputs)
	if (locale === "zh") return zh_attr_yield(inputs)
	if (locale === "vi") return vi_attr_yield(inputs)
	return en_attr_yield(inputs)
});